// extracted by mini-css-extract-plugin
export default {"ul":"UserNav_ul__EwVk9","li":"UserNav_li__jqrpK","link":"UserNav_link__Enrd3","img":"UserNav_img__8zi+D","exit":"UserNav_exit__db1Ft"};